import { useTheme } from '@mui/material/styles';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';
import { ActualIconProps } from 'mobx/commonTypes';
import React, { useContext } from 'react';
import { UiContext } from 'uiContext';
import cx from 'classnames';

export default function IconCar({
  onClick,
  extColor,
  isAutoscallable = true,
  sizeKey = '16x16',
  style,
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      className={cx('icon IconCar', onClick ? '' : 'icon_disabled')}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 17 16"
      fill={fill}
    >
      <path d="M12.9336 3.66666C12.8002 3.26659 12.4336 3 12 3H4.66672C4.23312 3 3.86659 3.26659 3.73312 3.66666L2.33337 7.33334V12.3333C2.33337 12.6999 2.6335 13 3.00003 13H3.66672C4.03325 13 4.33337 12.6999 4.33337 12.3333V12H12.3334V12.3333C12.3334 12.6999 12.6335 13 13 13H13.6667C14.0332 13 14.3334 12.6999 14.3334 12.3333V7.33334L12.9336 3.66666ZM4.66672 10C4.10031 10 3.66672 9.56672 3.66672 9C3.66672 8.43328 4.10031 8 4.66672 8C5.23312 8 5.66672 8.43331 5.66672 9C5.66672 9.56669 5.23312 10 4.66672 10ZM12 10C11.4336 10 11 9.56672 11 9C11 8.43328 11.4336 8 12 8C12.5664 8 13 8.43331 13 9C13 9.56669 12.5664 10 12 10ZM3.66672 6.66666L4.66672 4H12L13 6.66666H3.66672Z" />
    </svg>
  );
}
